import { KipUser } from "../dto/KipUser";

export class ShortTaskItem {
  Id: number;
  AssignedTo?: number;
  Supervisor?: number;
  Type: string; // (C)leaning (M)aintenance
  Users : KipUser[];
}
